import { configureStore, type UnknownAction } from '@reduxjs/toolkit'

import { talkJsSlice } from '~/store/talkJsState'

import { mainReducer } from '../rtk/mainSlice'
import { getInitialData, MainState } from './get-initial-data'

const talkJsReducer = talkJsSlice.reducer

export const getStore = (initialState?: Partial<MainState>) => {
    const preloadedState = getInitialData(initialState)

    const reducer = (state: MainState | undefined, action: UnknownAction) => {
        const mainState = mainReducer(state, action)
        return {
            ...mainState,
            talkJs: talkJsReducer(mainState.talkJs, action),
        }
    }

    return configureStore({
        reducer,
        preloadedState,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware({
            serializableCheck: false,
        }),
    })
}

export type AppStore = ReturnType<typeof getStore>
export type RootState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']
